import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, watch } from "vue";
import Multiselect from "vue-multiselect";
import { useMultiselect } from "@/composables/useMultiselect";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormSelect',
    props: {
        multiple: { type: Boolean, default: false },
        optional: { type: Boolean, default: false },
        options: null,
        value: { default: null }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const { ariaExpanded, onOpen, onClose } = useMultiselect();
        /**
         * Determine dom wrapper class
         */
        const cls = computed(() => {
            return props.multiple ? "form-select-multiple" : "form-select-single";
        });
        /**
         * Configure deselect label
         */
        const deselectLabel = computed(() => {
            return props.multiple ? "Click to remove" : "";
        });
        /**
         * Translates input options for consumption by the
         * select component into an array of objects
         */
        const formattedOptions = computed(() => {
            const result = props.options.map((option) => ({
                label: option[0],
                value: option[1],
            }));
            if (props.optional && !props.multiple) {
                result.unshift({
                    label: "Nothing selected",
                    value: null,
                });
            }
            return result;
        });
        /**
         * Tracks if the select field has options
         */
        const hasOptions = computed(() => {
            return formattedOptions.value.length > 0;
        });
        /**
         * Provides initial value if necessary
         */
        const initialValue = computed(() => {
            if (props.value === null && !props.optional && hasOptions.value) {
                const v = formattedOptions.value[0];
                if (v) {
                    return v.value;
                }
            }
            return null;
        });
        /**
         * Configure selected label
         */
        const selectedLabel = computed(() => {
            return props.multiple ? "Selected" : "";
        });
        /**
         * Tracks selected values
         */
        const selectedValues = computed(() => {
            return Array.isArray(props.value) ? props.value : [props.value];
        });
        /**
         * Tracks current value and emits changes
         */
        const currentValue = computed({
            get: () => formattedOptions.value.filter((option) => selectedValues.value.includes(option.value)),
            set: (val) => {
                if (Array.isArray(val)) {
                    if (val.length > 0) {
                        const values = val.map((v) => v.value);
                        emit("input", values);
                    }
                    else {
                        emit("input", null);
                    }
                }
                else {
                    emit("input", val ? val.value : null);
                }
            },
        });
        /**
         * Ensures that an initial value is selected for non-optional inputs
         */
        function setInitialValue() {
            if (initialValue.value) {
                emit("input", initialValue.value);
            }
        }
        /**
         * Watches changes in select options and adjusts initial value if necessary
         */
        watch(() => props.options, () => setInitialValue());
        /**
         * Sets initial value if necessary
         */
        onMounted(() => {
            setInitialValue();
        });
        return { __sfc: true, ariaExpanded, onOpen, onClose, props, emit, cls, deselectLabel, formattedOptions, hasOptions, initialValue, selectedLabel, selectedValues, currentValue, setInitialValue, Multiselect };
    }
});
